import {  useEffect} from "react";
import { useDispatch } from "react-redux";
// import { createAction } from "./utils/reducer/reducer.util";
// import { onAuthStateChangedListner,   createUserDocumentFromAuth, getCurrentUser} from "./utils/firebase/firebase.util";
import { checkUserSession } from "./store/user/user.action";

import Home from './routes/home/home.component';
import Authentication from './routes/authentication/authentication.component';
import SignUpForm from './components/sign-up/sign-up-form/sign-up-form.componenet';
import {Routes,Route ,Outlet} from 'react-router-dom'

import Directory from './components/directory/directory-component';
import Navigation from './routes/navigation/naviagtion.component';
import Shop from './routes/shop/shop.component';
import Checkout from './routes/Checkout/checkout.component';



const App=() => {
  const dispatch=useDispatch()

  useEffect(()=>{
    dispatch(checkUserSession())
    
  //   const unsubcribe = onAuthStateChangedListner((user)=>{
  //     if(user){
  //        createUserDocumentFromAuth(user)
  //     }
  //    dispatch(setCurrentUser(user));
  // })

  // return unsubcribe;
    
  },[])
    


  return( 
  <Routes>
    <Route path='/' element={<Navigation />}>
    <Route index element={<Home/>} />
    <Route path='shop/*' element={<Shop/>} />



      <Route path='auth' element={<Authentication/>} />
      <Route path='checkout' element={<Checkout/>} />
      
      
    
      </Route>
    
  </Routes>
  )
}

export default App;
